import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import { Dropdown, DropdownMenu } from '../Dropdown';
import { Input } from '../Input';
import { InputIconInside } from '../InputWrapper';
import classNames from 'classnames'
import inputStyles from '../Input/Input.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

function Select({ itens, ...props }) {
  const [expanded, setExpanded] = useState(false)
  const [value, setValue] = useState('')
  const [menuItens, setMenuItens] = useState([])

  function toggleExpanded() {
    setExpanded(() => !expanded)
  }

  const addItens = obj => {
    setMenuItens(current => [...current, obj]);
  };

  useEffect(() => {
    itens.map((item, index) => {

      if (item.selected)
        setValue(itens[index].label)

      if (!!item.group_label)
        return addItens({ group_label: true, label: item.group_label })

      return addItens({
        label: item.label,
        value: !!item.value ? item.value : index,
        handler: () => {
          setValue(item.label)
          setExpanded(false)
        }
      })
    })
  }, [])

  const ref = useRef(null)

  useEffect(() => {
    const clickedOutside = (e) => {
      if (expanded && ref.current && !ref.current.contains(e.target)) {
        setExpanded(false)
      }
    }
    document.addEventListener('mousedown', clickedOutside)
    return () => {
      document.removeEventListener('mousedown', clickedOutside)
    }
  }, [expanded])

  const { className, ...rest } = props;

  return (
    <div ref={ref} className={className}>
      <Dropdown {...rest}>
        <InputIconInside
          expandable
          onClick={toggleExpanded}
          iconRight={
            expanded ? (
              <MdArrowDropUp onClick={toggleExpanded} />
            ) : (
              <MdArrowDropDown onClick={toggleExpanded} />
            )
          }
        >
          <Input value={value} iconInsideRight />
        </InputIconInside>
        <DropdownMenu
          visible={expanded}
          itens={menuItens}
          style={{ width: '100%' }}
        />
      </Dropdown>
    </div>
  )
}

function SelectNative_({ small, large, ...props }, ref) {

  const { className, ...rest } = props;
  const childrenClassNames = classNames([
    generalStyle.general_style,
    inputStyles.input,
    small && inputStyles.sm,
    large && inputStyles.lg
  ], className)

  return (
    <select ref={ref} className={childrenClassNames} {...rest}>
      {props.children}
    </select>
  );
};

const SelectNative = forwardRef(SelectNative_);

export { Select, SelectNative }